document.addEventListener("DOMContentLoaded", () => {
    const hideElementsByClass = (parent, className) => {
        if (!parent) 
            return;
        
        parent.querySelectorAll(className).forEach(element => {
            element.style.display = "none";
        });
    };
    const handlePriceVisibility = () => {
        //parent has TD
        const priceTax = document.querySelector("[bss-b2b-product-form-id] [bss-b2b-product-qb-id]");
        //parent no TD
        const priceTaxQB = document.querySelector("div.bss-b2b-qty-table-wrapper");
        if (! priceTax || ! priceTaxQB) 
            return;
        
        const hasNoVatClass = priceTax.querySelector(".bss-b2b-price-no-vat");
        const hasVatClass = priceTax.querySelector(".bss-b2b-price-has-vat");
        if (hasNoVatClass && hasVatClass) 
            return;
        
        if (! hasNoVatClass) 
            hideElementsByClass(priceTaxQB, ".bss-b2b-price-no-vat");
        
        if (! hasVatClass) 
            hideElementsByClass(priceTaxQB, ".bss-b2b-price-has-vat");
        
    };
    const observer = new MutationObserver(() => handlePriceVisibility());
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    handlePriceVisibility();
});